import "public/css/components.contents.scss";
import React from "react";
import PropTypes from "prop-types";
import ModuleConfiguration from "./model";

export function Message({
    type,
    text,
    style,
    children,
}) {
    return <p className={ `message-${type}` } style={ style || null } >
        { text || children }
    </p>
    ;
}

Message.propTypes = {
    type : PropTypes.string.isRequired,
    style: PropTypes.object,
    text: PropTypes.node,
    children: PropTypes.node,
};

/**
 * @return {null}
 */
export default function MessageRender({
    configuration,
    invalid,
    sendStatus,
}) {

    if (invalid === true && configuration.inputMessage.active) {
        return <Message
            type="error"
            text={ configuration.inputMessage.text }
        >
        Please enter a valid email.
        </Message>;
    }

    if (sendStatus === false && ( configuration.successMessage.active || configuration.errorMessage.active)) {
        return <Message
            type="error"
            text={ configuration.errorMessage.text }
            style={ configuration.errorMessage.style }
        >
          An error occured while attempting to validate your email.
        </Message>;

    }

    if (sendStatus === true && configuration.successMessage.active ) {
        return <Message
            type="success"
            text={ configuration.successMessage.text }
            style={ configuration.successMessage.style }
        >
          Your email is successfully registered.
        </Message>;
    }

    return null;
}

MessageRender.propTypes = {
    configuration: PropTypes.instanceOf(ModuleConfiguration).isRequired,
    sendStatus: PropTypes.bool,
    invalid: PropTypes.bool,
};
